import { Controller } from "@hotwired/stimulus"

// After a visual option tile swaps the product_detail frame, brings the
// gallery back on screen so the customer sees the picked design large.
// Below lg the gallery sits above the info column, far from the tiles; on lg
// it is sticky and already in view, so nothing happens there. Only tile
// clicks trigger it, any other load of the frame keeps the scroll position.
//
// Connects to data-controller="gallery-reveal" on the product_detail frame
export default class extends Controller {
  remember(event) {
    this.tilePicked = Boolean(event.target.closest("[data-visual-option-tile]"))
  }

  reveal() {
    if (!this.tilePicked) return
    this.tilePicked = false
    if (window.matchMedia("(min-width: 64rem)").matches) return

    document.getElementById("image_gallery")?.scrollIntoView({ block: "start", behavior: "smooth" })
  }
}
